<script lang="ts">
  import BaseModule from '$src/js/app/base/BaseModule';
  import Svg from '$src/js/components/_base/svg/Svg.svelte';

  let theme = $state(window.localStorage.getItem('theme') ?? 'dark');

  const switchTheme = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark';

    // Set and store
    theme = newTheme;
    document.documentElement.setAttribute('data-theme', theme);

    try {
      window.localStorage.setItem('theme', theme);
    } catch {
      // ignore
    }

    BaseModule.getInstance().analytics.trackEvent({
      event: 'theme_switch',
      theme_value: newTheme,
    });

    // Close hamburger (on mobile)
    setTimeout(() => {
      BaseModule.getInstance().hamburger.close();
    }, 300);
  };
</script>

<div class="bg-surface-neutral-def-secondary inline-flex gap-0 rounded-sm">
  <button
    aria-label={BaseModule.getInstance().i18n.translate(`base_switch_theme`)}
    class="before:bg-surface-neutral-def-background relative m-0.5 flex h-7 w-14 before:absolute before:left-0 before:h-full before:w-1/2 before:rounded-sm before:transition-all before:duration-200 max-xl:m-1 max-xl:h-8 max-xl:w-16"
    class:before:left-[50%]={theme === 'light'}
    onclick={switchTheme}
  >
    <div class="relative z-10 flex h-full w-1/2 items-center justify-center">
      <Svg icon="moon" size="16" className="fill-text-neutral-def-base max-xl:size-4.5" />
    </div>
    <div class="relative z-10 flex h-full w-1/2 items-center justify-center">
      <Svg icon="sun" size="16" className="fill-text-neutral-def-base max-xl:size-4.5" />
    </div>
  </button>
</div>
